import Customer, {
  CustomerDeliveryAddress,
  CustomerDTO,
} from "@/model/customer";
import { ItemCategory } from "@/model/item";
import PaginateModel from "@/model/paginate";
import User, { UserDTO } from "@/model/user";
import Production, { ProductionDTO } from "@/model/production";
import api from "./api";
import { AxiosResponse } from "axios";

interface RequestInterface {
  data: CustomerDTO[];
}
interface RequestUserInterface {
  data: UserDTO[];
}

interface ResponseProductionInterface {
  data: ProductionDTO[];
  paginate: any;
}

interface ResponseItemCategoryInterface {
  data: ItemCategory[];
}

interface ResponseInterface {
  status: string;
  message: string;
  errors: any;
}

interface ProductionList {
  list: Production[];
  paginate: any;
}

class CustomerApi extends api {
  constructor() {
    super();
    this.setup();
  }
  async getAllCustomers(): Promise<Customer[]> {
    const response = await this.getHttp().get<RequestInterface>(
      "admin-customer/customers"
    );
    const list: Customer[] = [];
    response.data.data.map((customerDto) =>
      list.push(new Customer(customerDto))
    );

    return list;
  }

  async getProductions(query): Promise<ProductionList> {
    const response = await this.getHttp().get<ResponseProductionInterface>(
      "customer/productions",
      {
        params: query,
      }
    );
    const list: Production[] = [];
    response.data.data.map((productionDTO) =>
      list.push(new Production(productionDTO))
    );
    const paginate = new PaginateModel(response.data.paginate.ItemCartons);
    return {
      list: list,
      paginate: paginate,
    };
  }

  async getAllCategory(query): Promise<ItemCategory[]> {
    const response = await this.getHttp().get<ResponseItemCategoryInterface>(
      "customer/item-categories",
      {
        params: query,
        data: {
          notLoading: true,
        },
      }
    );
    const list: ItemCategory[] = [];
    response.data.data.map((ItemDto) => list.push(new ItemCategory(ItemDto)));
    return list;
  }
  async deleteCart(id) {
    const response = await this.getHttp().delete<ResponseInterface>(
      `customer/carts/${id}`
    );
    return response;
  }

  async getCustomer(): Promise<AxiosResponse> {
    return this.getHttp().get<Customer>("/customer/customers/view");
  }

  async editCustomerDeliveryAddress(data): Promise<AxiosResponse> {
    return this.getHttp().post<CustomerDeliveryAddress>(
      "/customer/edit-customer-delivery",
      data
    );
  }
  async deleteCustomerDeliveryAddress(id): Promise<AxiosResponse> {
    return this.getHttp().delete("/customer/delete-customer-delivery/" + id);
  }

  async getCustomers(): Promise<User[]> {
    const response = await this.getHttp().get<RequestUserInterface>(
      "/customer/users",
      {
        data: {
          notLoading: true,
        },
      }
    );
    const list: User[] = [];
    response.data.data.map((userDto) => list.push(new User(userDto)));
    return list;
  }

  async getHoliday(): Promise<any> {
    const response = await this.getHttp().get("/customer/holiday");
    return response.data.data.map((item) => item.date);
  }

  async checkOrder(data): Promise<any> {
    const response = await this.getHttp().post("/customer/check-carts", data);
    return response.data.errors;
  }

  async addOrder(data): Promise<any> {
    const response = await this.getHttp().post("/customer/orders", data);
    return response.data;
  }

  async getInitDataSearch(): Promise<AxiosResponse> {
    return this.getHttp().get("/get-init-data-search/");
  }
}

export default new CustomerApi();
